import { api } from '../services/axiosConfig';
import { CharacterSummary } from '../types';

export const fetchCharacters = () => api.get<CharacterSummary[]>('/api/characters').then((r) => r.data);

export const setActiveCharacter = (eveCharacterId: number) =>
  api.post('/api/characters/active', { eveCharacterId });

export const setMainCharacter = (eveCharacterId: number) =>
  api.post(`/api/characters/${eveCharacterId}/main`);

export const unlinkCharacter = (eveCharacterId: number) =>
  api.delete(`/api/characters/${eveCharacterId}`);

export const startReauth = (eveCharacterId: number) =>
  api.post<{ auth_url: string }>(`/api/auth/reauth/${eveCharacterId}`).then((r) => r.data);

/** Self-service: sends the given linked character through SSO with the
 * roles-read scope, then the callback checks whether ESI actually reports
 * 'Director' and stamps eve_characters.esi_director_verified_at accordingly.
 * See routes/auth.ts POST /api/auth/director-reauth/:characterId. */
export const startDirectorVerify = (eveCharacterId: number) =>
  api.post<{ auth_url: string }>(`/api/auth/director-reauth/${eveCharacterId}`).then((r) => r.data);

export const startLinkCharacter = () =>
  api.post<{ auth_url: string }>('/api/auth/link').then((r) => r.data);

export interface RosterEntry {
  eveCharacterId: number;
  name: string;
  isMain: boolean;
  online: boolean | null;
  /** Three states, not two: ESI can also tell us nothing. 'unknown' must not
   * be drawn the same as 'offline' — one means "not playing", the other means
   * "we have no idea, and possibly haven't for days". */
  presence: 'online' | 'offline' | 'unknown';
  /** 'auth_expired' needs the user to re-link that character;
   * 'esi_unavailable' resolves itself. */
  presenceReason: 'auth_expired' | 'esi_unavailable' | null;
  solarSystemId: number | null;
  systemName: string | null;
  systemClass: string | null;
  shipTypeName: string | null;
}

export interface PresenceEntry {
  eve_character_id: number;
  character_name: string;
  solar_system_id: number;
  system_name: string;
  system_class: string | null;
  entered_at: string;
}

/** Where this account's characters have been in J-space, newest first —
 * written by the backend poller whether or not anyone had the app open, so
 * this shows entries you weren't around to see the live banner for. */
export const fetchPresenceHistory = () =>
  api.get<PresenceEntry[]>('/api/characters/presence').then((r) => r.data);

export const fetchRoster = () => api.get<RosterEntry[]>('/api/characters/roster').then((r) => r.data);
